




































import Vue from 'vue';
import { API } from '@/api';
import { mapActions } from 'vuex';

export default Vue.extend({
  data: () => ({
    openDialog: false,
    rules: [(v) => v.length === 18 || 'La CLABE debe ser de 18 caracteres'],
    nuevaContable: {
      descripcion: '',
      numCuenta: '',
      tipo: '',
    },
    tipos: [
      { value: 'MAYOR'},
      { value: 'AUXILIAR'},
    ],
    loading: false,
    isTipoEmpty: true,
  }),
  mounted() {
    this.loadData();
  },
  methods: {
    ...mapActions(['getImpuesto']),
    modeloContable() {
      return {
        descripcion: '',
        numCuenta: '',
        tipo: '',
      };
    },
    async loadData() {
      return;
    },
    async AgregarContable() {
      let permitir = true;
      for (const prop in this.nuevaContable) {
        if (this.nuevaContable[prop].length === 0) {
          permitir = false;
          break;
        }
      }
      if (!permitir) {
        this.$toast.error('Es necesario poner un número, descripción y tipo de cuenta contable.');
        return;
      }
      try {
        this.loading = true;
        const admin = this.$store.getters.getAdmin;
        const condo = this.$store.getters.getCondo;
        const contable = this.nuevaContable;
        const datos = {admin, condo, contable};
        console.log('datos: %o', datos);
        const result = await this.$store.dispatch('addContable', {datos} );
        console.debug('Respuesta addContable: %o', result);
        this.$toast.success('Cuenta contable agregada');
      } catch (e) {
        console.error(e);
        this.$toast.error(e.response.data.message);
      }
      this.loading = false;
      this.openDialog = false;
      this.$emit('reload', {});
    },
  },
  watch: {
    openDialog() {
      if (!this.openDialog) {
        this.nuevaContable = this.modeloContable();
      }
    },
    'nuevaContable.tipo'() {
      if (this.nuevaContable.tipo === '') {
        this.isTipoEmpty = true;
      } else {
        this.isTipoEmpty = false;
      }
    },
  },
});
